import React, { useState } from 'react';
import { array, string, func } from "prop-types";
import { Grid } from "@material-ui/core";
import { FilterDropDownBlue } from '@worthy-npm/clarity';

import { itemTypeToSystemFormat, createItemTypeChangeEvent } from './RecentDealsContainer';

export const changeHistoryState = (type) => history.pushState({}, '' , type ? `/about/recent-deals/${type}` : '/about/recent-deals'); // in order to don`t add / in the end for all case

const ItemTypesSelect = ({ itemTypes, selectedValueType, onTypeChange, addTabClickedGAEvent }) => {
    const [selectedType, setSelectedType] = useState(selectedValueType);
    const itemTypesInOptionsFormat = itemTypes.map(type => ({ label: type[0] === 'Loose Diamonds' ? 'Diamonds' : type[0], value: itemTypeToSystemFormat(type[0]) }));

    return (
        <Grid item xs={6}
              style={{alignSelf: 'center'}}
              className='mobile-filter-select'
        >
            <FilterDropDownBlue
                defaultValue={selectedType}
                options={itemTypesInOptionsFormat}
                onChange={(value) => {
                    setSelectedType(value);
                    addTabClickedGAEvent(value);
                    changeHistoryState(value === 'all' ? '' : value);
                    window.dispatchEvent(createItemTypeChangeEvent(value));
                    onTypeChange(value);
                }}
                overrideCSS={{font: '400 16px Roboto', lineHeight: '2.1em'}}
            />
        </Grid>
    )};

ItemTypesSelect.propTypes = {
    itemTypes: array,
    selectedValueType: string,
    onTypeChange: func,
    addTabClickedGAEvent: func,
};

export default ItemTypesSelect;
